import { UseFormRegisterReturn } from 'react-hook-form';
import { InterestRadioButton } from './interest-radio-button';
import { Typography } from '@/components';
import { t } from 'i18next';

interface DevelopmentStagesSectionProps {
  stages: { label: string; value: string }[];
  registration: Partial<UseFormRegisterReturn>;
  selectedStages: string[];
  isCompanyForm?: boolean;
  idPrefix?: string;
}

export function DevelopmentStagesSection({
  stages,
  registration,
  selectedStages,
  isCompanyForm,
  idPrefix,
}: DevelopmentStagesSectionProps) {
  return (
    <div className="space-y-2">
      {isCompanyForm ? (
        <div className="mb-4 space-y-0.5">
          <Typography as="h4" color="primary" size="body-2" weight="semibold">
            {t('Development Status')}
          </Typography>
        </div>
      ) : (
        <div className="space-y-0.5">
          <Typography as="h4" color="primary" size="title" weight="semibold">
            {t('In what development stages?')}
          </Typography>
          <Typography as="p" size="body-3" color="secondary" weight="normal" className="mt-1">
            {t('You can select more than one option')}
          </Typography>
        </div>
      )}
      <div className="flex flex-wrap justify-left gap-2 md:justify-start">
        {stages.map(({ label, value }) => (
          <InterestRadioButton
            key={value}
            id={`${idPrefix}-${value}`}
            value={value}
            registration={registration}
            isSelected={selectedStages.includes(value)}
          >
            <span>{label}</span>
          </InterestRadioButton>
        ))}
      </div>
    </div>
  );
}
